import * as React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import clsx from 'clsx';
import FancyTitle from './fancy-title';

function TextSection({
  title,
  subtitle,
  text,
  image,
  link,
  altText,
  textAlign,
  useSrcImage,
}) {
  const titleComponent = title && (
    <FancyTitle
      tag='h2'
      text={title}
      marginBottom='mb-0'
      textAlign={textAlign}
      className={!subtitle && 'pb-4 lg:pb-0'}
    />
  );
  const subtitleComponent = subtitle && (
    <p
      className={clsx(
        'text-latori-green my-4 font-monospace text-center lg:text-left uppercase text-xl',
        textAlign
      )}>
      {subtitle}
    </p>
  );
  return (
    <div className='grid lg:grid-cols-6 items-center gap-0 gap-y-4 lg:gap-16'>
      <div className='w-[calc(100vw-2rem)] lg:w-full lg:col-span-4'>
        {title && <div className='block lg:hidden'>{titleComponent}</div>}
        {subtitle && <div className='block lg:hidden'>{subtitleComponent}</div>}
        {!useSrcImage ? (
          <GatsbyImage
            image={image}
            alt={altText || text || title}
            className='w-[calc(100vw-2rem)] lg:w-full h-full lg:max-h-screen aspect-square'
          />
        ) : (
          <img src={image.filename} alt={image.alt}/>
        )}
      </div>
      <div className='flex flex-col col-span-2 mx-auto lg:mx-0'>
        {title && <div className='hidden lg:block'>{titleComponent}</div>}
        {subtitle && <div className='hidden lg:block'>{subtitleComponent}</div>}
        {text && (
          <div>
            <p
              className={clsx(
                'prose dark:prose-invert px-4 md:px-0',
                textAlign
              )}>
              {text}
            </p>
          </div>
        )}
        {link?.url && (
          <Link
            to={link.url}
            className='button-primary self-center lg:self-start mt-4 w-fit'>
            {link.label}
          </Link>
        )}
      </div>
    </div>
  );
}

export default TextSection;
